import { ParticipantLoginForm } from '@/ui/ParticipantLoginForm';

export function LoginPage() {
  return (
    <section className="panel panel--login">
      <ParticipantLoginForm />
    </section>
  );
}
